import React, { Component } from 'react';
import Select from 'react-dropdown-select';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getCSAProductList, sendCsaProductSearchValue,getStoreSoh,getPriceDetails,getApplicableSchemes,getSchemes } from "../../actions/csaApp";
import noImage  from '../../assets/images/noProductImg_420x420.jpg'
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { addToCart } from '../../actions/cart'
import { shopBagDefault } from '../common/MangoIcons'
import simpleValidator from 'simple-react-validator'
import Modal from 'react-responsive-modal';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import { getWebSessionId } from '../../actions/user';
import { toast } from 'react-toastify';



class ProductList extends Component{
    constructor(){
        super()
        this.state = {
            selectedColor : null,
            selectedSize : null,
            detailPageLoading: true,
            open: false,productcode:'', size: '',
            open1: false,
            matches : window.matchMedia("(max-width: 500px)").matches
        }
        this.validator = new simpleValidator();
    }
 
    componentDidMount = async() => {
        // // const productCode = localStorage.getItem('csa_product_code');
        // const storeFlag = localStorage.getItem('csa_storeFlag');
        // const skuCode = localStorage.getItem('csa_sku_id');
        // const barcode = localStorage.getItem('barcode')

        // if(this.props.csaProducts.length === 0){
        //     this.props.history.push('/csa-search')
        //     if((productCode !== null && productCode !=='') || (skuCode !== null && skuCode!== '') || (barcode !== null && barcode!== '' )){
        //     const { connection_id, getCSAProductList, sendCsaProductSearchValue } = this.props;
        //     let options = {
        //         "connection_id": connection_id,
        //         "product_id": productCode,
        //         "sku_id":skuCode,
        //         "barcode":barcode,
        //         "store_flag":storeFlag,
        //         "size_id":  [],
        //         "color_id":  [],
        //         "brand_code":[],
        //             "category_id":[],
        //             "gender_id":[
                       
        //             ],
                   
        //             "new_arrivals":"",
        //             "price_start_range":0,
        //             "price_end_range":9999999,
                    
        //            "page":""
        //         }
                
        //         await getCSAProductList(options)
        //         sendCsaProductSearchValue(options)
        //     }
        // }
    //     if(this.props.web_session_trans_id == null || this.props.web_session_trans_id == ''){
    //     await this.props.getWebSessionId( this.props.connection_id );
    // }
         setTimeout(() => {
             this.setState({
                 detailPageLoading: false
             })
             }, 500)
        

    }
    onOpenModal = () => {
        this.setState({ open: true });
    };
    onOpenModal1 = (productcode,size) => {
        this.setState({ open1: true,productcode, size });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };
    onCloseModal1 = () => {
        this.setState({ open1: false });
    };
    handleColorChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }
    
     handleAddToCart = (item, quantity) => {
        const tenant_category = this.props.tenant_details && this.props.tenant_details.TEN_BUSINESS_CATEGORY_CD
             const fromAllStore =  localStorage.getItem('fromAll') ;
                const { connection_id, web_session_trans_id, store_details,Order_type ,consumer_mobile_no} = this.props
                let booking_storeid = store_details.store_code;
                const options = {
                    connection_id,
                    web_session_trans_id,
                    booking_storeid,
                    consumer_mobile_no,
                    quantity,
                    lot_code: fromAllStore ==='yes' || tenant_category !== 'JEWLLARY' ?  item.QOL_LOT_CD : item.LSN_RFID_TAG_SLNO,
                    barcode: fromAllStore ==='yes' || tenant_category !== 'JEWLLARY' ? item.QOL_EAN_CD : item.LSN_RFID_TAG_SLNO,
                    RID_CART_ORDER_TYPE:fromAllStore ==='yes' ? "A" : 'H',

                }
                if(consumer_mobile_no){
                    this.props.addToCart(options)
                }

                else {
                    this.props.history.push(`/update`)
                }
            }
             handleAddToCart1 = (item, quantity) => {
             
                const { connection_id, web_session_trans_id, store_details,Order_type ,consumer_mobile_no} = this.props
                let booking_storeid = store_details.store_code;
                const options = {
                    connection_id,
                    web_session_trans_id,
                    booking_storeid,
                    consumer_mobile_no,
                    quantity,
                    lot_code: item.RID_RFID_TAG_SLNO,
                    barcode: item.RID_RFID_TAG_SLNO,
                    RID_CART_ORDER_TYPE: 'H',

                }
                if(consumer_mobile_no){
                    this.props.addToCart(options)
                }

                else {
                    this.props.history.push(`/update`)
                }
            }
                
     
            handleBack = () => {
                this.props.history.push('/csa-search')
              }
            //   handleColorChange = (value) => {
            //     // event.preventDefault();
            //      if (value.length > 0){
                     
            //      this.setState({
            //         selectedColor: value,
            //         // sizeSelected: []
            //      }) 
            //     }}

    handleFilterProduct = (e) => {

        e.preventDefault();
    if (this.validator.allValid()) {
        const { getCSAProductList, sendCsaProductSearchValue } = this.props;
        const { selectedColor, selectedSize} = this.state;
        let opt = JSON.parse(localStorage.getItem('optionValue'))
    opt.color_id=selectedColor === null ? [] : [selectedColor];
    opt.size_id =selectedSize === null ? [] : [selectedSize];

       
            getCSAProductList(opt)
            sendCsaProductSearchValue(opt)
    }
    else {
        this.validator.showMessages();
        this.forceUpdate();
    }
        
    }

    handleSoh = async (sku_cd, product_code, size) => {
        let fromStore = localStorage.getItem('fromAll') === 'yes' ? 'AL' : 'TS'; ;
        let option = {
            connection_id: this.props.connection_id,
            sku_cd: sku_cd,
            fromStore: fromStore
        }
        await this.props.getStoreSoh(option);
        this.onOpenModal1(product_code, size);
    }
           
handleAvailable=async (pid)=>{
    const fromAllStore =  localStorage.getItem('fromAll') ;
    
    let option = {
        connection_id : this.props.connection_id,
        product_id : pid,
        web_session_id : this.props.web_session_trans_id+'A' //a for avoid Duplicate serial no - Serial No already in use
    }

    let data = {
        connection_id : this.props.connection_id,
        product_id : pid,
        web_session_id : this.props.web_session_trans_id+'A',
        qty:'1',
        ean:pid,
        RID_CART_ORDER_TYPE :  fromAllStore === 'yes' ? "A" : 'H',
        ORDER_SUB_TYPE : fromAllStore === 'yes' ? "MTO" : ''
        
      }
    await this.props.getApplicableSchemes(data);

      await this.props.getPriceDetails(option);
      await this.props.getSchemes(option);


    if(this.props.applicableShemes && this.props.applicableShemes.RESULT ){
        toast.error(this.props.applicableShemes.RESULT);
        return;
    }
    this.onOpenModal();

}

    render(){
        const { csaVariants, csaProducts, loading ,addToCart,priceDetails,store_details,schemes,storeSoh,serialNoDetails} = this.props;
        const fromAllStore =  localStorage.getItem('fromAll') 
        const {open} = this.state;
        const tenant_category = this.props.tenant_details && this.props.tenant_details.TEN_BUSINESS_CATEGORY_CD

        console.log(csaProducts,'csaProducts')
        console.log(serialNoDetails,'serialNoDetails')
        console.log(store_details,'store_details')
        if (this.state.detailPageLoading ) {
            return (
                <div>
                    <div className="product-wrapper-grid">
                        <div className="container-fluid">
                            <div className="loading-cls"></div>
                        </div>
                    </div>
                </div>
            )
        }
      

        return(
                <section className="tab-product m-0">
                <div className="csa-product-list">
                    <div className="container">
                        <div className="container-tab mx-auto">
                            <div class="row">
                                {csaProducts.length === 0 && store_details && store_details.tenant_name == 'Goldiam International Limited' && serialNoDetails   ?
                                 <div class="col-md-8 mx-auto">
                                    <div className="row" style={{paddingBottom:10}}>
                                        <div className="col-sm-12 text-center">
                                            <div className="mini-title">
                                                <span className="mx-auto">Product List</span>
                                            </div>
                                        </div>
                                    </div>
                            <div className="collection-wrapper">
                                            
                                        {   Object.keys(serialNoDetails).length === 0 || serialNoDetails.RESULT ? 
                                           <React.Fragment>
                                                <div className="row" style={{ padding: 15}}>
                                    <div className="col-md-5">
                                        <div className="size-box" style={window.innerWidth < 789 ? {display:'flex', marginBottom: 15,}:{}}>
                                            <div className="col-md-1 col-sm-1   col-xs-1" style={{ paddingLeft: 0, paddingRight: 0, textAlign: "left",fontSize:16 }}>
                                                    Color
                                                </div>
                                            <div className="col-md-12 col-sm-12   col-xs-12" style={window.innerWidth < 789 ? { paddingLeft: 0, paddingRight: 0,marginLeft:'-70%' }:{ paddingLeft: 0, paddingRight: 0}}>
                                                <select className={"form-control font-arr"}  onChange={(e)=>this.handleColorChange(e)} value={this.state.selectedColor} name="selectedColor" style={{ textAlignLast:'center'}}>
                                                {window.innerWidth <= 320 ?      
                                                <option value="" >&emsp;&emsp;&emsp;Select
                                                 Color</option>
                                                 : window.innerWidth <= 400 ?
                                                 <option value="" >&emsp;&emsp;&emsp;&emsp;Select
                                                 Color</option> 
                                                 : window.innerWidth <= 480 ? 
                                                 <option value="" >&emsp;&emsp;&emsp;&emsp;&emsp;Select
                                                 Color</option> :
                                                   <option value="" >Select
                                                   Color</option> }
                                               
                                                {csaVariants && csaVariants[0] && csaVariants[0].PDM_VARIANT_DETAIL && csaVariants[0].PDM_VARIANT_DETAIL.map((colors, i) =>
                                                <option key={i} value={colors.SKU_VARIANT_VALCD}>{colors.SKU_VARIANT_VALUE_DESC}</option>
                                                    )}
                                                </select> <br/>
                   <span style={{textAlign:'center'}}> {this.validator.message('Color', this.state.selectedColor, 'required')}</span>

                                               
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-5" >
                                        <div className="size-box" style={window.innerWidth < 789 ? {display:'flex', marginBottom: 15,}:{}}>
                                            <div className="col-md-1 col-sm-1   col-xs-1" style={{ paddingLeft: 5, paddingRight: 0, textAlign: "left",fontSize:16 }}>
                                                  Size
                                                </div>
                                            <div className="col-md-12 col-sm-12   col-xs-12" style={window.innerWidth < 789 ? { paddingLeft: 0, paddingRight: 0,marginLeft:'-70%'  }:{ paddingLeft: 0, paddingRight: 0}}>
                                                <select className={"form-control font-arr"} onChange={(e)=>this.handleColorChange(e)} value={this.state.selectedSize} name="selectedSize" style={{ textAlignLast:'center'}}>
                                                {window.innerWidth <= 320 ?      
                                                <option value="" >&emsp;&emsp;&emsp;Select
                                                 Size</option>
                                                 : window.innerWidth <= 400 ?
                                                 <option value="" >&emsp;&emsp;&emsp;&emsp;Select
                                                 Size</option> 
                                                 : window.innerWidth <= 480 ? 
                                                 <option value="" >&emsp;&emsp;&emsp;&emsp;&emsp;Select
                                                 Size</option> :
                                                   <option value="" >Select
                                                   Size</option> }
                                                {csaVariants && csaVariants[1] && csaVariants[1].PDM_VARIANT_DETAIL && csaVariants[1].PDM_VARIANT_DETAIL.map((sizes, i) =>
                                                <option key={i} value={sizes.SKU_VARIANT_VALCD}>{sizes.SKU_VARIANT_VALUE_DESC}</option>
                                                    )}
                                                </select>  <br/>
                   <span style={{textAlign:'center'}}> {this.validator.message('Size', this.state.selectedSize, 'required')}</span>


                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="col-md-2">
                                        <div className="size-box" style={{ paddingTop: 0,textAlignLast:'center'}}>
                                                <button className="btn btn-solid btn-filter" type="submit" onClick={(e) => this.handleFilterProduct(e)}>Go</button>
                                        </div>
                                    </div>
                                </div>
                                                <h4 className="text-center" style={{marginBottom:20}}>{serialNoDetails.RESULT}</h4>
                                                <h3 className="text-center" style={{marginBottom:20}}>Product Not Available</h3>

                                                
                                            </React.Fragment> :
                                           
                                                    <React.Fragment>

                                                    <div className="row">
                                                        <div className="col-md-4 product-thumbnail" style={{textAlign:'center'}}>
                                                        <div><Link to={`${process.env.PUBLIC_URL}/PD/${serialNoDetails.RID_LOT_CD}`}>
                                                            <img className="img-fluid product-img" src={serialNoDetails.RID_IMAGE_FILE_NAME !== null && serialNoDetails.RID_IMAGE_FILE_NAME !== "" ? serialNoDetails.RID_IMAGE_FILE_NAME : noImage} alt="" />
                                                        </Link></div>
                                                                <div  style={{ paddingTop:10}}>
                                                                    <div style={{padding:'0px 0px 10px',justifyContent:'center',display:'flex'}}>
                                                                        <button className="btn btn-sm">In stock : {serialNoDetails.RID_SOH}</button></div>
                                                                        <div>
                                                                        <b className="btn btn-solid" style={{ flexGrow: 9, backgroundSize: 1188 ,padding: '2px 31px'}} onClick={(e) => this.handleAddToCart1(serialNoDetails, 1)}>add to cart</b>
                                                                    
                                                                    </div>  

                                                                </div>
                                                        </div>
                                                        <div className="col-md-8" style={{ paddingTop:10}}>
                                                            <div className='row'>
                                                                <div className="w_50 col-4" style={{padding:'0px 0px 0px 15px'}}>
                                                                    <b>
                                                                        Product Code  
                                                                    </b>
                                                                </div><div className='col-1'>:</div>
                                                                <div className="w_50 col">
                                                                    {serialNoDetails.RID_PRODUCT_CD}
                                                                </div>
                                                                </div>
                                                               { tenant_category == 'JEWLLARY' ?
                                                                <div className='row'>
                                                                <div className="w_50 col-4" style={{padding:'0px 0px 0px 15px'}}>
                                                                    <b>
                                                                        Serial No.  
                                                                    </b>
                                                                </div><div className='col-1'>:</div>
                                                                <div className="w_50 col">
                                                                    {serialNoDetails.RID_RFID_TAG_SLNO}
                                                                </div>
                                                                </div> : '' }
                                                                <div className='row'>
        
                                                                <div className="w_50 col-4">
                                                                    <b>
                                                                        Category  
                                                                    </b>
                                                                </div>
                                                                <div className='col-1'>:</div>
                                                                <div className="w_50 col">
                                                                    {serialNoDetails.SKU_HNODE_DESC}
                                                                </div>
                                                                </div>
                                                                <div className='row'>
                                                                <div className="w_50 col-4">
                                                                    <b>
                                                                        Sku Code  
                                                                    </b>
                                                                </div>
                                                                <div className='col-1'>:</div>

                                                                <div className="w_50 col">
                                                                    {serialNoDetails.RID_SKU_CD}
                                                                </div>
                                                                </div>
                                                                <div className='row'>
                                                                <div className="w_50 col-4">
                                                                    <b>
                                                                        Size 
                                                                    </b>
                                                                </div>
                                                                <div className='col-1'>:</div>

                                                                <div className="w_50 col">
                                                                    {serialNoDetails.SKU_VARIANT2_VALUE_DESC}/{serialNoDetails.SKU_VARIANT3_VALUE_DESC}
                                                                </div>
                                                                </div>
                                                                <div className='row'>
                                                                <div className="w_50 col-4">
                                                                    <b>
                                                                        Color  
                                                                    </b>
                                                                </div>
                                                                <div className='col-1'>:</div>

                                                                <div className="w_50 col">
                                                                    {serialNoDetails.SKU_VARIANT1_VALUE_DESC}
                                                                </div>
                                                                </div>
                                                                <div className='row'>
                                                                <div className="w_50 col-4">
                                                                    <b>
                                                                        MRP 
                                                                    </b>
                                                                </div>
                                                                <div className='col-1'>:</div>

                                                                <div className="w_50 col">
                                                                    {serialNoDetails.RID_PRICE}
                                                                </div>
                                                                </div>
                                                                <div className='row'>
                                                               <div className="w_50 col-4"><b>Offers </b></div>
                                                               <div className='col-1'>:</div>                                                               
                                                                <div className="w_50 col">
                                                             {serialNoDetails.DISC_ITEM_DESC}
                                                                </div> 
                                                            </div>
                                                            

                                                            {store_details && store_details.tenant_name == 'Goldiam International Limited' ?
                                                            <div className='row'>
                                                                <div className="w_50 col-4" style={{    padding: "6px 10px"}}>
                                                                <button className='btn btn-solid' onClick={()=>this.handleAvailable(serialNoDetails.RID_RFID_TAG_SLNO)} style={{padding:"0px 10px" ,fontSize:'10px'}}>Price Detail</button>
                                                                   
                                                                </div>
                                                                <div className='col-1'></div>

                                                                <div className="w_50 col">
                                                                </div></div> : '' }
                                                           
                                                           
                                                        </div>
                                                    </div>
                                                   
                                                   
                                                    </React.Fragment>
    }                            
     <div style={{ display: "flex", justifyContent: "space-between", padding:20 }}>
                        <div style={{ flexGrow: 5, textAlign: "center" }}>
                          <button type="button" className="btn btn-solid" style={{ width: "50%" }}
                            onClick={() => this.handleBack()}>Back</button>
                        </div></div>     
                                            
                                            
                                            
                                        </div>    </div>
                             :
                                <div class="col-md-8 mx-auto">

                                    {/* Title */}

                                    <div className="row" style={{paddingBottom:10}}>
                                        <div className="col-sm-12 text-center">
                                            <div className="mini-title">
                                                <span className="mx-auto">Product List</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Search Form */}

                                    <div className="row" style={{ padding: 15}}>
                                    <div className="col-md-5">
                                        <div className="size-box" style={window.innerWidth < 789 ? {display:'flex', marginBottom: 15,}:{}}>
                                            <div className="col-md-1 col-sm-1   col-xs-1" style={{ paddingLeft: 0, paddingRight: 0, textAlign: "left",fontSize:16 }}>
                                                    Color
                                                </div>
                                            <div className="col-md-12 col-sm-12   col-xs-12" style={window.innerWidth < 789 ? { paddingLeft: 0, paddingRight: 0,marginLeft:'-70%' }:{ paddingLeft: 0, paddingRight: 0}}>
                                                <select className={"form-control font-arr"}  onChange={(e)=>this.handleColorChange(e)} value={this.state.selectedColor} name="selectedColor" style={{ textAlignLast:'center'}}>
                                                {window.innerWidth <= 320 ?      
                                                <option value="" >&emsp;&emsp;&emsp;Select
                                                 Color</option>
                                                 : window.innerWidth <= 400 ?
                                                 <option value="" >&emsp;&emsp;&emsp;&emsp;Select
                                                 Color</option> 
                                                 : window.innerWidth <= 480 ? 
                                                 <option value="" >&emsp;&emsp;&emsp;&emsp;&emsp;Select
                                                 Color</option> :
                                                   <option value="" >Select
                                                   Color</option> }
                                               
                                                {csaVariants && csaVariants[0] && csaVariants[0].PDM_VARIANT_DETAIL && csaVariants[0].PDM_VARIANT_DETAIL.map((colors, i) =>
                                                <option key={i} value={colors.SKU_VARIANT_VALCD}>{colors.SKU_VARIANT_VALUE_DESC}</option>
                                                    )}
                                                </select> <br/>
                   <span style={{textAlign:'center'}}> {this.validator.message('Color', this.state.selectedColor, 'required')}</span>

                                               
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-5" >
                                        <div className="size-box" style={window.innerWidth < 789 ? {display:'flex', marginBottom: 15,}:{}}>
                                            <div className="col-md-1 col-sm-1   col-xs-1" style={{ paddingLeft: 5, paddingRight: 0, textAlign: "left",fontSize:16 }}>
                                                  Size
                                                </div>
                                            <div className="col-md-12 col-sm-12   col-xs-12" style={window.innerWidth < 789 ? { paddingLeft: 0, paddingRight: 0,marginLeft:'-70%'  }:{ paddingLeft: 0, paddingRight: 0}}>
                                                <select className={"form-control font-arr"} onChange={(e)=>this.handleColorChange(e)} value={this.state.selectedSize} name="selectedSize" style={{ textAlignLast:'center'}}>
                                                {window.innerWidth <= 320 ?      
                                                <option value="" >&emsp;&emsp;&emsp;Select
                                                 Size</option>
                                                 : window.innerWidth <= 400 ?
                                                 <option value="" >&emsp;&emsp;&emsp;&emsp;Select
                                                 Size</option> 
                                                 : window.innerWidth <= 480 ? 
                                                 <option value="" >&emsp;&emsp;&emsp;&emsp;&emsp;Select
                                                 Size</option> :
                                                   <option value="" >Select
                                                   Size</option> }
                                                {csaVariants && csaVariants[1] && csaVariants[1].PDM_VARIANT_DETAIL && csaVariants[1].PDM_VARIANT_DETAIL.map((sizes, i) =>
                                                <option key={i} value={sizes.SKU_VARIANT_VALCD}>{sizes.SKU_VARIANT_VALUE_DESC}</option>
                                                    )}
                                                </select>  <br/>
                   <span style={{textAlign:'center'}}> {this.validator.message('Size', this.state.selectedSize, 'required')}</span>


                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="col-md-2">
                                        <div className="size-box" style={{ paddingTop: 0,textAlignLast:'center'}}>
                                                <button className="btn btn-solid btn-filter" type="submit" onClick={(e) => this.handleFilterProduct(e)}>Go</button>
                                        </div>
                                    </div>
                                </div>

                               {/* Product List */}
                               {fromAllStore === 'yes' ?  <div className='row'><div className='col' style={{textAlignLast:'center',padding:15}} >
                              <div style={{margin:'0px 30px',background:'whitesmoke',padding:10,fontWeight:'normal',borderRadius:5}}> 
                               <h5 style={{fontWeight:'normal',fontSize:16,}}><span>Product not available in store </span>
                               <br/><span>&nbsp;&nbsp;Stock available at other stores.</span></h5>
                              </div>
                              </div></div> :''}
                               {/* {localStorage.removeItem('fromAll')} */}
                      <div style={{padding:'5px 15px 15px 15px'}}>
                                    <div className="collection-wrapper">
                                            
                                        {csaProducts.length > 0 ?
                                            csaProducts.map((item, index) => {
                                                return (
                                                    <React.Fragment>

                                                    <div className="row">
                                                        <div className="col-md-4 product-thumbnail" style={{textAlign:'center'}}>
                                                        <div><Link to={`${process.env.PUBLIC_URL}/PD/${item.QOL_LOT_CD}`}>
                                                            <img className="img-fluid product-img" src={item.SKU_IMAGE !== null && item.SKU_IMAGE !== "" ? item.SKU_IMAGE : noImage} alt="" />
                                                        </Link></div>
                                                                <div  style={{ paddingTop:10}}>
                                                                    <div style={{padding:'0px 0px 10px',justifyContent:'center',display:'flex'}}>
                                                                        <button className="btn btn-sm">In stock : {item.QOL_FREE_QOH}</button></div>
                                                                        <div>
                                                                        <b className="btn btn-solid" style={{ flexGrow: 9, backgroundSize: 1188 ,padding: '2px 31px'}} onClick={(e) => this.handleAddToCart(item, 1)}>add to cart</b>
                                                                    
                                                                    </div>  

                                                                </div>
                                                        </div>
                                                        <div className="col-md-8" style={{ paddingTop:10}}>
                                                            <div className='row'>
                                                                <div className="w_50 col-4" style={{padding:'0px 0px 0px 15px'}}>
                                                                    <b>
                                                                        Product Code  
                                                                    </b>
                                                                </div><div className='col-1'>:</div>
                                                                <div className="w_50 col">
                                                                    {item.SKU_PRODUCT_CD}
                                                                </div>
                                                                </div>
                                                                 {fromAllStore !== 'yes' &&  tenant_category === 'JEWLLARY' ?
                                                                <div className='row'>
                                                                <div className="w_50 col-4" style={{padding:'0px 0px 0px 15px'}}>
                                                                    <b>
                                                                        Serial No. 
                                                                    </b>
                                                                </div><div className='col-1'>:</div>
                                                                <div className="w_50 col">
                                                                    {item.LSN_RFID_TAG_SLNO}
                                                                </div>
                                                                </div> : '' }
                                                                <div className='row'>
        
                                                                <div className="w_50 col-4">
                                                                    <b>
                                                                        Category  
                                                                    </b>
                                                                </div>
                                                                <div className='col-1'>:</div>
                                                                <div className="w_50 col">
                                                                    {item.SKU_HNODE_DESC}
                                                                </div>
                                                                </div>
                                                                <div className='row'>
                                                                <div className="w_50 col-4">
                                                                    <b>
                                                                        Sku Code  
                                                                    </b>
                                                                </div>
                                                                <div className='col-1'>:</div>

                                                                <div className="w_50 col">
                                                                    {item.QOL_SKU_CD}
                                                                </div>
                                                                </div>
                                                                <div className='row'>
                                                                <div className="w_50 col-4">
                                                                    <b>
                                                                        Size 
                                                                    </b>
                                                                </div>
                                                                <div className='col-1'>:</div>

                                                                <div className="w_50 col">
                                                                    {item.SKU_VARIANT2_VALUE_DESC} {tenant_category == 'JEWLLARY' && fromAllStore != 'yes'?<span> / {item.SKU_VARIANT3_VALUE_DESC}</span> : ''}
                                                                </div>
                                                                </div>
                                                                <div className='row'>
                                                                <div className="w_50 col-4">
                                                                    <b>
                                                                        Color  
                                                                    </b>
                                                                </div>
                                                                <div className='col-1'>:</div>

                                                                <div className="w_50 col">
                                                                    {item.SKU_VARIANT1_VALUE_DESC}
                                                                </div>
                                                                </div>
                                                                <div className='row'>
                                                                <div className="w_50 col-4">
                                                                    <b>
                                                                        MRP 
                                                                    </b>
                                                                </div>
                                                                <div className='col-1'>:</div>

                                                                <div className="w_50 col">
                                                                    {item.QOL_PRICE}
                                                                </div>
                                                                </div>
                                                                <div className='row'>
                                                               <div className="w_50 col-4"><b>Offers </b></div>
                                                               <div className='col-1'>:</div>                                                               
                                                                <div className="w_50 col">
                                                             {item.DISC_ITEM_DESC}
                                                                </div> 
                                                            </div>
                                                            {/* { store_details && store_details.tenant_name == 'D Samson Industries (Pvt) Ltd' ? */}
                                                            {/* <div className="row" style={{marginTop:'35px',marginLeft:'35px'}}>
                                                                    <div style={{ textAlign: 'center' }}
                                                                        className="w_50 col-12 link-style"
                                                                        onClick={() => this.handleSoh(item.QOL_LOT_CD, item.SKU_PRODUCT_CD, item.SKU_VARIANT2_VALUE_DESC)}
                                                                    >
                                                                        View Store SOH
                                                                    </div>
                                                                </div>
                                                                 {/* : '' } */}

                                                            {/* { store_details && store_details.tenant_name == 'Goldiam International Limited' ?
                                                            <div className='row' style={{marginTop:'-27px',width:'50%'}}>
                                                                <div className="" style={{    padding: "6px 10px"}} >
                                                                <button className='btn btn-solid' onClick={()=>this.handleAvailable(item.QOL_SKU_CD)} style={{padding:"0px 10px" ,fontSize:'10px'}}>Price Detail</button>
                                                                   
                                                                </div>
                                                                <div className='col-1'></div>

                                                                <div className="w_50 col">
                                                                </div></div> : '' } */} 
                                                           
                                                                { store_details && store_details.tenant_name == 'Goldiam International Limited' ?

                                                                    <div className="row" style={{marginTop:'26px'}}>
                                                                        <div className="col" style={{    padding: "6px 10px"}} >
                                                                <button className='btn btn-solid' onClick={()=> fromAllStore !== 'yes' ?  this.handleAvailable(item.LSN_RFID_TAG_SLNO) : this.handleAvailable(item.QOL_SKU_CD)} style={{padding:"0px 10px" ,fontSize:'10px'}}>Price Detail</button>
                                                                   
                                                                </div>
                                                                    <div style={{ textAlign: 'center',paddingTop:6 }}
                                                                        className="w_50 col link-style"
                                                                        onClick={() => this.handleSoh(item.QOL_LOT_CD, item.SKU_PRODUCT_CD, item.SKU_VARIANT2_VALUE_DESC)}
                                                                    >
                                                                        View Store SOH
                                                                    </div>
                                                                    </div>:<div className="row" style={{marginTop:'35px',marginLeft:'35px'}}>
                                                                    <div style={{ textAlign: 'center' }}
                                                                        className="w_50 col-12 link-style"
                                                                        onClick={() => this.handleSoh(item.QOL_LOT_CD, item.SKU_PRODUCT_CD, item.SKU_VARIANT2_VALUE_DESC)}
                                                                    >
                                                                        View Store SOH
                                                                    </div>
                                                                    </div>}
                                                                
                                                           
                                                        </div>
                                                    </div>
                                                   
                                                    {csaProducts.length - 1 !== index && 
                                                    <hr role="tournament6"/>
                                                    }
                                                    </React.Fragment>
                                                )
                                                
                                            }
                                            ) 
                                             :
                                             
                                            <React.Fragment>
                                                
                                                <h3 className="text-center" style={{marginBottom:20}}>Product Not Available</h3>
                                                
                                            </React.Fragment>
                                            } 
                                            
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "space-between", padding:20 }}>
                        <div style={{ flexGrow: 5, textAlign: "center" }}>
                          <button type="button" className="btn btn-solid" style={{ width: "50%" }}
                            onClick={() => this.handleBack()}>Back</button>
                        </div></div>
                                    </div>
                                


                                </div> 
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    open={this.state.open1}
                    onClose={this.onCloseModal1}
                    center
                    classNames={{ modal: 'custom-modal' }}
                >
                    <div className="custom-content">
                        <div
                            className="custom-body"
                            style={this.state.matches ? {} : { overflow: 'hidden' }}
                        >

                            <Table style={{ width: '-webkit-fill-available' }}>
                                <Tbody>
                                    <Tr><th style={{ paddingRight: '30px' }}>Product Code
                                    </th><td >{this.state.productcode}</td></Tr>
                                    <Tr><th style={{ padding: '10px 0px' }}>Product Size</th><td  > {this.state.size}</td></Tr>
                                    <Tr><Td colSpan={3}><hr style={{ marginTop: 6, marginBottom: 6, borderTop: '1px solid lightgrey' }} /></Td></Tr>
                                    <Tr>
                                        <th style={{ minWidth: '120px', maxWidth: '180px', whiteSpace: 'pre-line', wordBreak: 'break-word' }}>Store Name</th>
                                        <th style={{ minWidth: '100px', maxWidth: '140px', whiteSpace: 'pre-line', wordBreak: 'break-word' }}>City</th>
                                        <th>Qty</th>
                                    </Tr>
                                    <Tr><Td colSpan={3}><hr style={{ marginTop: 6, marginBottom: 6, borderTop: '1px solid lightgrey' }} /></Td></Tr>
                                </Tbody>
                            </Table>
                            <Table style={{ display: 'block', overflowY: 'scroll', height: '250px' }}>
                                <Tbody>
                                    {storeSoh && storeSoh.StoreSoh && storeSoh.StoreSoh.length > 0 ?  storeSoh.StoreSoh.map((store, index) => (
                                        <Tr key={index}>
                                            <td style={{ minWidth: '120px', maxWidth: '180px', whiteSpace: 'pre-line', wordBreak: 'break-word', paddingRight: 30 }}>{store.store_short_name}</td>
                                            <td style={{ minWidth: '100px', maxWidth: '140px', whiteSpace: 'pre-line', wordBreak: 'break-word', paddingRight: 30 }}>{store.store_city}</td>
                                            <td>{store.fre_soh}</td>
                                        </Tr>
                                    )) : ''}
                                </Tbody>
                            </Table>
                        </div>
                    </div>
                </Modal>


                
                <Modal open={open} onClose={this.onCloseModal} center style={{width:'10%'}}>
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document" >
                        <div className="modal-content quick-view-modal">
<div className="modal-body" style={this.state.matches ? {}: {overflow:'hidden'}}>
                                <Table>
                                    <Tbody>
                                        <Tr>
                                            <Td>Gold Rate</Td>
                                            {/* <Td>:</Td>k */}
                                            <Td>{priceDetails && priceDetails.GOLD_RATE}</Td>
                                            <Td>Gold Wt(g)</Td>
                                            {/* <Td>:</Td> */}
                                            <Td>{priceDetails && priceDetails.GOLD_WEIGHT}</Td>
                                            
                                        </Tr>
                                        <Tr>
                                        <Td>Gross Wt(g)</Td>
                                            {/* <Td>:</Td> */}
                                            <Td style={{textAlign:'end'}}>{priceDetails && priceDetails.GROSS_WEIGHT}</Td>
                                           
                                            <Td>Diamond Wt(Ct)</Td>
                                            {/* <Td>:</Td> */}
                                            <Td style={{textAlign:'end'}}>{priceDetails && priceDetails.DIAMOND_WEIGHT}</Td>
                                        </Tr>
</Tbody></Table>
<Table><Tbody>
                                            <Tr><Td colSpan={5}><hr style={{ marginTop: 2, marginBottom: 2, borderTop: '1px solid lightgrey' }} /></Td></Tr>
                                        <Tr style={{ fontWeight: 'bold' }}>
                                            <Td colSpan={2}>Price </Td>
                                            <Td >Value</Td>
                                            <Td>Discount</Td>
                                            <Td style={{textAlign:'end'}} >Nett Value</Td>

                                        </Tr>
                                        <Tr><Td colSpan={5}><hr style={{ marginTop: 2, marginBottom: 2, borderTop: '1px solid lightgrey' }} /></Td></Tr>

                                        <Tr>
                                            <Td colSpan={2}>Gold</Td>
                                            <Td style={{ textAlign: 'end' }}>{priceDetails && priceDetails.GOLD_AMT}</Td>
                                            <Td style={{ textAlign: 'end' }}>{priceDetails && priceDetails.GOLD_DISCOUNT_AMT ? priceDetails.GOLD_DISCOUNT_AMT : '0.00'}</Td>
                                            <Td  style={{ textAlign: 'end' }}>{priceDetails && priceDetails.GOLD_NET_AMT}</Td>

                                        </Tr>
                                        <Tr>
                                            <Td colSpan={2}>Diamond</Td>
                                            <Td style={{ textAlign: 'end' }}>{priceDetails && priceDetails.DIAMOND_AMT}</Td>
                                            <Td style={{ textAlign: 'end' }}>{priceDetails && priceDetails.DIAMOND_DISCOUNT_AMT ? priceDetails.DIAMOND_DISCOUNT_AMT : '0.00'}</Td>
                                            <Td  style={{ textAlign: 'end' }}>{priceDetails && priceDetails.DIAMOND_NET_AMT}</Td>

                                        </Tr>
                                        <Tr>
                                            <Td colSpan={2}>Mk Chrg</Td>
                                            <Td style={{ textAlign: 'end' }}> {priceDetails && priceDetails.MC_AMT}</Td>
                                            <Td style={{ textAlign: 'end' }}>{priceDetails && priceDetails.MC_DISCOUNT_AMT ? priceDetails.MC_DISCOUNT_AMT : '0.00'}</Td>
                                            <Td  style={{ textAlign: 'end' }}>{priceDetails && priceDetails.MC_NET_AMT}</Td>

                                        </Tr>

                                        <Tr><Td colSpan={5}><hr style={{ marginTop: 2, marginBottom: 2, borderTop: '1px solid lightgrey' }} /></Td></Tr>
                                        <Tr>
                                            <Td colSpan={2}>
                                            Prod. Price
                                            </Td>
                                            <Td style={{ textAlign: 'end' }}>
                                                {priceDetails && parseFloat(parseFloat(priceDetails.GOLD_AMT) + parseFloat(priceDetails.DIAMOND_AMT) + parseFloat(priceDetails.MC_AMT)).toFixed(2)}
                                            </Td>
                                            <Td style={{ textAlign: 'end' }}>
                                            {priceDetails && parseFloat(parseFloat(priceDetails.GOLD_DISCOUNT_AMT ? priceDetails.GOLD_DISCOUNT_AMT: 0)  +  parseFloat(priceDetails.DIAMOND_DISCOUNT_AMT ? priceDetails.DIAMOND_DISCOUNT_AMT : 0)  +  parseFloat(priceDetails.MC_DISCOUNT_AMT ? priceDetails.MC_DISCOUNT_AMT:0)  ).toFixed(2)}

                                            </Td>
                                            <Td  style={{ textAlign: 'end' }}>
                                            {priceDetails && parseFloat(parseFloat(priceDetails.GOLD_NET_AMT) + parseFloat(priceDetails.DIAMOND_NET_AMT) + parseFloat(priceDetails.MC_NET_AMT)).toFixed(2)}

                                            </Td>
                                        </Tr>
                                        <Tr><Td colSpan={5}><hr style={{ marginTop: 2, marginBottom: 2, borderTop: '1px solid lightgrey' }} /></Td></Tr>

                                        <Tr>
                                            <Td colSpan={2}>
                                            Prod. Disc
                                            </Td>
                                            <Td >
                                         
                                            </Td>
                                            <Td style={{ textAlign: 'end' }}></Td>
                                            <Td  style={{ textAlign: 'end' }}>
                                            {priceDetails && priceDetails.RID_DISC_AMT ? priceDetails.RID_DISC_AMT : 0.00}
                                            </Td>
                                        </Tr>
                                        <Tr>
                                            <Td colSpan={2}>
                                                Bill Disc
                                            </Td>
                                            <Td >

                                            </Td>
                                            <Td style={{ textAlign: 'end' }}></Td>
                                            <Td  style={{ textAlign: 'end' }}>
                                            {priceDetails && priceDetails.RID_GROUP_BILL_DISC_AMT ? priceDetails.RID_GROUP_BILL_DISC_AMT : 0.00}

                                            </Td>
                                        </Tr>
                                        <Tr><Td colSpan={5}><hr style={{ marginTop: 2, marginBottom: 2, borderTop: '1px solid lightgrey' }} /></Td></Tr>
                                       <Tr></Tr>
                                        <Tr>
                                            <Td colSpan={2}>Basic Price</Td>
                                            <Td style={{ textAlign: 'end' }}>
                                            {priceDetails && parseFloat(parseFloat(priceDetails.GOLD_AMT) + parseFloat(priceDetails.DIAMOND_AMT) + parseFloat(priceDetails.MC_AMT)).toFixed(2)}
                                                
                                            </Td>
                                            <Td style={{ textAlign: 'end' }}></Td>
                                            <Td  style={{ textAlign: 'end' }}>   
                                            {priceDetails && parseFloat((parseFloat(priceDetails.GOLD_NET_AMT) + parseFloat(priceDetails.DIAMOND_NET_AMT) + parseFloat(priceDetails.MC_NET_AMT))-(priceDetails.RID_DISC_AMT ? parseFloat(priceDetails.RID_DISC_AMT):parseFloat(0.00))-(priceDetails.RID_GROUP_BILL_DISC_AMT?parseFloat(priceDetails.RID_GROUP_BILL_DISC_AMT):parseFloat(0.00))).toFixed(2)}
                                            </Td>
                                        </Tr>
                                        <Tr><Td colSpan={5}><hr style={{ marginTop: 2, marginBottom: 2, borderTop: '1px solid lightgrey' }} /></Td></Tr>

                                        <Tr>

                                            <Td colSpan={2}>GST</Td>
                                            <Td >
                                            {priceDetails && priceDetails.RET_TAX_AMT ? priceDetails.RET_TAX_AMT : "0.00"}

                                            </Td>
                                            <Td style={{ textAlign: 'end' }}></Td>
                                            <Td  style={{ textAlign: 'end' }}>
                                            {priceDetails && priceDetails.RID_TAX_AMT ? priceDetails.RID_TAX_AMT : "0.00"}

                                                </Td>
                                        </Tr>
                                        <Tr>
                                            <Td colSpan={2}>Net. Price</Td>
                                            <Td style={{ textAlign: 'end' }}>
                                            {priceDetails && (parseFloat(priceDetails.RET_TAX_AMT)  + parseFloat(priceDetails.GOLD_AMT) + parseFloat(priceDetails.DIAMOND_AMT) + parseFloat(priceDetails.MC_AMT)  ).toFixed(2)}

                                            </Td>
                                            <Td style={{ textAlign: 'end' }}></Td>
                                            <Td  style={{ textAlign: 'end' }}>
                                            {priceDetails && parseFloat((parseFloat(priceDetails.GOLD_NET_AMT) + parseFloat(priceDetails.DIAMOND_NET_AMT) + parseFloat(priceDetails.MC_NET_AMT) + parseFloat(priceDetails.RID_TAX_AMT))-(priceDetails.RID_DISC_AMT ? parseFloat(priceDetails.RID_DISC_AMT):parseFloat(0.00))-(priceDetails.RID_GROUP_BILL_DISC_AMT?parseFloat(priceDetails.RID_GROUP_BILL_DISC_AMT):parseFloat(0.00))).toFixed(2)}

                                                </Td>
                                        </Tr>
                                        <Tr><Td colSpan={5}><hr style={{ marginTop: 25, marginBottom: 2, borderTop: '1px solid lightgrey' }} /></Td></Tr>
                                       </Tbody></Table>
                                       <Table>
                                        <Tbody>
                                        <Tr>
                                            <Th >Scheme Code</Th>
                                            <Th></Th>
                                            <Th>Scheme Description</Th>
                                            

                                        </Tr>
                                        <Tr><Td colSpan={3}><hr style={{ marginTop: 2, marginBottom: 2, borderTop: '1px solid lightgrey' }} /></Td></Tr>
                                       
                                        {schemes.length > 0 && schemes.map((scheme,index)=>(
  
         <Tr id={index.toString()} key={index} >
                                            <Td >{scheme.SCD_SCHEME_CD}</Td>
                                            <Td></Td>
                                            <Td style={{width:'200px'}}>{scheme.SCD_DESCRIPTION}</Td>
                                            
                                        </Tr> 
))}
                            </Tbody>
                            </Table>            


                                   
           
                
                            </div>
                        </div>
                    </div>
                </Modal>
                </section>        
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    csaVariants: state.csa.csaVariants,
    connection_id: state.tenant.connection_id,
    csaProducts: state.csa.csaProducts,
    priceDetails: state.csa.priceDetails,
    storeSoh: state.csa.storeSoh,
    schemes: state.csa.schemes,
    serialNoDetails: state.csa.serialNoDetails,
    applicableShemes : state.csa.applicableShemes,
    tenant_details: state.tenant.tenant_details,


    loading: state.csa.loading,
    csaSearchValue: state.csa.csaSearchValue,
    Order_type: state.tenant.Order_type,
    store_details: state.tenant.store_details,
    web_session_trans_id: state.user.user_details && state.user.web_session_trans_id,

    consumer_mobile_no: state.user.user_details && state.user.user_details.COM_CONSUMER_MOBILE_NO,
    

});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { getCSAProductList,getStoreSoh,getPriceDetails,getSchemes, sendCsaProductSearchValue,addToCart,getApplicableSchemes,getWebSessionId },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ProductList));
